var scope_0 = require('/vercel/6261093a/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/229ba94b89b94ca3dc3786373c507056.js').default;
var scope_1 = require('/vercel/6261093a/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8900fe8459c7fbb549726942c56f4eee.js').default;
var scope_2 = require('/vercel/6261093a/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9a87e30f01d5522571223156714663de.js').default;
var scope_3 = require('/vercel/6261093a/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a777b73033c96a5ae8822f3363e55f9d.js').default;
var scope_4 = require('/vercel/6261093a/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c2d06d27cb849ee62b69798f95054767.js').default;
var scope_5 = require('/vercel/6261093a/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    